import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const aiAnswersRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-virtualagent-ai-answers',
	exact: true,
	path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/ai-answers',
};
